/**
 * Determines if a banner has a light background and applies dark title text.
 *
 * Priority:
 * 1. data-bg="light" / data-bg="dark" on the banner wrapper → manual override
 * 2. Canvas pixel sampling (works only if CDN allows CORS)
 * 3. data-ec-promo-id list — hardcoded fallback for known light banners
 *
 * Usage:
 *   setBannerColors({ lightPromoIds: [32, 45] })
 *   — OR add data-bg="light" attribute directly to a .banner-wrapper element
 */
import {
  handleSecondDescriptionPosition,
  initMobileCategoryControls,
  handleVisitedProducts,
  handleReadMoreBtn,
} from "./components/category";
handleSecondDescriptionPosition();
document.addEventListener("DOMContentLoaded", handleSecondDescriptionPosition);
document.addEventListener(
  "ShoptetDOMContentLoaded",
  handleSecondDescriptionPosition
);
function setBannerColors() {
  document.querySelectorAll(".banner-wrapper").forEach((wrapper) => {
    // Priority 1: explicit data-bg attribute on the wrapper element
    const dataBg = wrapper.dataset.bg;
    if (dataBg === "light") {
      wrapper.classList.add("banner--light");
      return;
    }
    if (dataBg === "dark") {
      return;
    }

    // Priority 2: #light marker in the image alt text (set in Shoptet admin)
    const img = wrapper.querySelector("img");
    if (img && img.alt.includes("#light")) {
      wrapper.classList.add("banner--light");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const savedScrollY = sessionStorage.getItem("restoreScrollY");
  if (savedScrollY !== null) {
    sessionStorage.removeItem("restoreScrollY");
    window.scrollTo(0, parseInt(savedScrollY));
  }

  const topNavMenu = document.querySelector(
    ".top-navigation-bar .top-navigation-menu"
  );
  const navigationButtons = document.querySelector(
    "#header .navigation-buttons"
  );

  if (topNavMenu && navigationButtons) {
    navigationButtons.parentNode.insertBefore(topNavMenu, navigationButtons);
  }

  const topNavTools = document.querySelector(".top-navigation-tools");
  if (topNavTools && topNavMenu) {
    topNavMenu.appendChild(topNavTools);
  }

  const menuHelper = document.querySelector(".menu-helper");
  const navigationIn = document.querySelector(".navigation-in");

  if (menuHelper && navigationIn) {
    navigationIn.appendChild(menuHelper);
  }

  // const loginToggle = document.querySelector(
  //   '.toggle-window[data-target="login"]'
  // );
  // const cartCount =
  //   navigationButtons && navigationButtons.querySelector(".cart-count");
  // if (loginToggle && cartCount) {
  //   navigationButtons.insertBefore(loginToggle, cartCount);
  // }

  const mediaLogosBanner = document
    .querySelector(".media-logos-section")
    ?.closest('[class*="custom-footer__banner"]');
  const footer = document.querySelector("#footer");
  if (mediaLogosBanner && footer) {
    footer.parentNode.insertBefore(mediaLogosBanner, footer);
  }

  const categoryChipsEl = document.querySelector(".category-chips");
  const categoryChipsBanner =
    categoryChipsEl?.closest('[class*="custom-footer__banner"]') ||
    categoryChipsEl?.closest(".banner-wrapper") ||
    categoryChipsEl;
  const beforeCarousel = document.querySelector(
    ".content-wrapper.homepage-box.before-carousel"
  );
  if (categoryChipsBanner && beforeCarousel) {
    beforeCarousel.after(categoryChipsBanner);
  }

  setBannerColors();

  initFaq();
  initProc();
  initFooterAccordion();
  if (window.innerWidth <= 767) initCartShowRelated();
  initMobileCartButtons();
  initMobileCategoryControls();
  initFavButtons();
  handleVisitedProducts();
  handleReadMoreBtn();
});
document.addEventListener("ShoptetDOMContentLoaded", () => {
  initMobileCategoryControls();
  initMobileCartButtons();
  if (window.innerWidth <= 767) initCartShowRelated();
  initFavButtons();
  handleVisitedProducts();
});

import {
  handleBlogReadMore,
  handleDmProductsPosition,
} from "./components/post";
document.addEventListener("DOMContentLoaded", handleBlogReadMore);
document.addEventListener("ShoptetDOMContentLoaded", handleBlogReadMore);
document.addEventListener("DOMContentLoaded", handleDmProductsPosition);

import {
  handleFooter,
  handleFooterBottom,
  recreateSignature,
} from "./utils/globalFunctions";
recreateSignature();
handleFooter();
handleFooterBottom();

function initFaq() {
  const section = document.querySelector(".faq-section");
  if (!section) return;

  const items = section.querySelectorAll(".faq-item");
  const triggers = section.querySelectorAll(".faq-item__trigger");
  const catBtns = section.querySelectorAll(".faq-section__cat");

  // Grid animation: remove hidden, wrap content so padding doesn't prevent collapse
  section.querySelectorAll(".faq-item__content").forEach((c) => {
    c.removeAttribute("hidden");
    const inner = document.createElement("div");
    inner.className = "faq-item__content-inner";
    while (c.firstChild) inner.appendChild(c.firstChild);
    c.appendChild(inner);
  });

  // Accordion
  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const isOpen = trigger.getAttribute("aria-expanded") === "true";
      const item = trigger.closest(".faq-item");

      triggers.forEach((t) => {
        t.setAttribute("aria-expanded", "false");
        t.closest(".faq-item")?.classList.remove("is-open");
      });

      if (!isOpen && item) {
        trigger.setAttribute("aria-expanded", "true");
        item.classList.add("is-open");
      }
    });
  });

  // Category filter
  function filterCategory(category) {
    items.forEach((item) => {
      const match = !category || item.dataset.category === category;
      item.hidden = !match;
      if (!match) {
        item
          .querySelector(".faq-item__trigger")
          ?.setAttribute("aria-expanded", "false");
        item.classList.remove("is-open");
      }
    });
  }

  catBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      catBtns.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      filterCategory(btn.dataset.category);
    });
  });

  // Show first category by default
  if (catBtns.length) filterCategory(catBtns[0].dataset.category);
}

function initFooterAccordion() {
  if (window.innerWidth > 767) return;
  const navSelectors = [
    ".custom-footer__banner7",
    ".custom-footer__banner8",
    ".custom-footer__banner9",
    ".custom-footer__banner10",
    ".custom-footer__banner15",
  ];
  document.querySelectorAll(navSelectors.join(",")).forEach((banner) => {
    const wrapper = banner.querySelector(".banner-wrapper");
    const h5 = wrapper?.querySelector("h5");
    if (!h5 || !wrapper) return;
    h5.addEventListener("click", () => {
      wrapper.classList.toggle("is-open");
    });
  });
}

function initProc() {
  const section = document.querySelector(".proc-section");
  if (!section) return;

  const tabs = section.querySelectorAll(".proc-tab");
  const panels = section.querySelectorAll(".proc-panel");
  const bg = section.querySelector(".proc-bg");

  // Product images in hidden panels — lazy load instead of eager preload
  section.querySelectorAll(".proc-panel img").forEach((img) => {
    img.loading = "lazy";
  });

  // Pre-set mobile background on every panel's .proc-product from its tab's data-bg
  tabs.forEach((tab) => {
    if (!tab.dataset.bg || !tab.dataset.panel) return;
    const panel = section.querySelector(
      `.proc-panel[data-panel="${tab.dataset.panel}"]`
    );
    const panelProduct = panel?.querySelector(".proc-product");
    if (panelProduct) {
      panelProduct.style.setProperty(
        "--proc-bg-img",
        `url('${tab.dataset.bg}')`
      );
    }
  });

  // Build one background layer per tab, stacked on top of each other. All four
  // images load up front, so switching is a pure-CSS opacity crossfade between
  // already-painted layers — no flash, no on-click loading, no JS timing logic.
  const bgLayers = {};
  if (bg) {
    bg.style.backgroundImage = "none"; // the layers carry the images now
    tabs.forEach((tab) => {
      if (!tab.dataset.bg || !tab.dataset.panel) return;
      const layer = document.createElement("div");
      layer.className = "proc-bg__layer";
      layer.style.backgroundImage = `url('${tab.dataset.bg}')`;
      if (tab.classList.contains("proc-tab--active")) {
        layer.classList.add("proc-bg__layer--active");
      }
      bg.appendChild(layer);
      bgLayers[tab.dataset.panel] = layer;
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => {
        t.classList.remove("proc-tab--active");
        t.setAttribute("aria-selected", "false");
      });
      panels.forEach((p) => (p.hidden = true));

      tab.classList.add("proc-tab--active");
      tab.setAttribute("aria-selected", "true");

      const layer = bgLayers[tab.dataset.panel];
      if (layer) {
        Object.values(bgLayers).forEach((l) =>
          l.classList.remove("proc-bg__layer--active")
        );
        layer.classList.add("proc-bg__layer--active");
      }

      const target = section.querySelector(
        `.proc-panel[data-panel="${tab.dataset.panel}"]`
      );
      if (target) target.hidden = false;
    });
  });
}

// Media logos — infinite auto-scroll via Slick (uses Shoptet's global jQuery)
import "slick-carousel";

function initDragScroll(el) {
  if (!el) return;
  let isDown = false,
    startX,
    scrollLeft;
  el.addEventListener("dragstart", (e) => e.preventDefault());
  el.addEventListener("mousedown", (e) => {
    isDown = true;
    el.classList.add("is-dragging");
    startX = e.pageX - el.offsetLeft;
    scrollLeft = el.scrollLeft;
  });
  el.addEventListener("mouseleave", () => {
    isDown = false;
    el.classList.remove("is-dragging");
  });
  el.addEventListener("mouseup", () => {
    isDown = false;
    el.classList.remove("is-dragging");
  });
  el.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    el.scrollLeft = scrollLeft - (e.pageX - el.offsetLeft - startX) * 1.5;
  });

  // Prevent Safari elastic overscroll at scroll boundaries (touch + trackpad)
  let touchStartX = 0;
  el.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.touches[0].clientX;
    },
    { passive: true }
  );
  el.addEventListener(
    "touchmove",
    (e) => {
      const dx = e.touches[0].clientX - touchStartX;
      const atStart = el.scrollLeft <= 0;
      const atEnd = el.scrollLeft >= el.scrollWidth - el.clientWidth - 1;
      if ((atStart && dx > 0) || (atEnd && dx < 0)) {
        e.preventDefault();
      }
    },
    { passive: false }
  );
}

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 767) {
    initDragScroll(document.querySelector(".media-logos-slider"));
    initDragScroll(
      document.querySelector(".before-carousel .content-wrapper-in")
    );
  }

  if (window.innerWidth > 767 || typeof window.$ === "undefined") return;
  const slider = document.querySelector(".media-logos-slider");
  if (!slider) return;

  window
    .$(".media-logos-slider")
    .on("init", function () {
      createSlickControls(this);
    })
    .slick({
      slidesToShow: 3,
      infinite: false,
      arrows: true,
      dots: true,
      responsive: [
        {
          breakpoint: 480,
          settings: { slidesToShow: 4, arrows: true, dots: true },
        },
      ],
    });
});

document.addEventListener("DOMContentLoaded", function () {
  if (typeof window.$ === "undefined") return;
  if (
    dataLayer[0].shoptet.pageType === "category" ||
    document.body.classList.contains("id--11")
  )
    return; // Skip on product pages where Slick is used for product images

  window
    .$(".products-block")
    .on("init", function () {
      const slider = this;
      if (window.innerWidth > 640) {
        const title = slider.previousElementSibling;
        if (!title || !title.classList.contains("homepage-group-title")) return;
        const prev = slider.querySelector(".slick-prev");
        const next = slider.querySelector(".slick-next");
        if (!prev || !next) return;
        const wrap = document.createElement("div");
        wrap.className = "slider-arrows";
        wrap.appendChild(prev);
        wrap.appendChild(next);
        title.appendChild(wrap);
      } else {
        createSlickControls(slider);
      }
    })
    .slick({
      slidesToShow: 5,
      infinite: false,
      responsive: [
        { breakpoint: 1260, settings: { slidesToShow: 3 } },
        { breakpoint: 964, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 2, arrows: false } },
        {
          breakpoint: 641,
          settings: { slidesToShow: 1.3, dots: true },
        },
      ],
    });
});

function initDmProductsSlick() {
  if (typeof window.$ === "undefined") return;
  if (window.innerWidth > 640) return;

  const runSlick = (el) => {
    if (el.querySelector(".slick-list")) return;
    const $el = window.$(el);
    $el.removeData("slick");
    el.classList.remove(
      "slick-initialized",
      "slick-slider",
      "slick-dotted",
      "slick-vertical"
    );
    $el
      .on("init", function () {
        createSlickControls(this);
      })
      .slick({ slidesToShow: 1.3, dots: true, arrows: true, infinite: false });
  };

  const waitForProducts = (el) => {
    if (el.querySelector(".product")) {
      runSlick(el);
      return;
    }
    const inner = new MutationObserver(() => {
      if (el.querySelector(".product")) {
        inner.disconnect();
        runSlick(el);
      }
    });
    inner.observe(el, { childList: true, subtree: true });
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.classList?.contains("dmproducts")) {
          waitForProducts(node);
        } else {
          node
            .querySelectorAll?.(".dmproducts.products-block")
            .forEach(waitForProducts);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document
    .querySelectorAll(".dmproducts.products-block")
    .forEach(waitForProducts);
}
document.addEventListener("DOMContentLoaded", initDmProductsSlick);
document.addEventListener("ShoptetDOMContentLoaded", initDmProductsSlick);

function initVisitedProductsSlick() {
  if (typeof window.$ === "undefined") return;
  if (window.innerWidth > 767) return;

  const runSlick = (el) => {
    const list = el.querySelector(".dvpnProducts");
    if (!list || list.querySelector(".slick-list")) return;
    list.querySelectorAll(".dvpnProducts__item").forEach((item) => {
      item.style.removeProperty("width");
      item.style.removeProperty("min-width");
      item.style.removeProperty("display");
    });
    list.style.removeProperty("width");
    window
      .$(list)
      .on("init", function () {
        createSlickControls(this);
      })
      .slick({
        slidesToShow: 2,
        dots: true,
        arrows: true,
        infinite: false,
        respondTo: "slider",
      });
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.classList?.contains("dkLabVisitedProductsNew")) {
          runSlick(node);
        } else {
          node.querySelectorAll?.(".dkLabVisitedProductsNew").forEach(runSlick);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll(".dkLabVisitedProductsNew").forEach(runSlick);
}
document.addEventListener("DOMContentLoaded", initVisitedProductsSlick);
document.addEventListener("ShoptetDOMContentLoaded", initVisitedProductsSlick);

function createSlickControls(slider) {
  const prev = slider.querySelector(".slick-prev");
  const dots = slider.querySelector(".slick-dots");
  const next = slider.querySelector(".slick-next");
  if (!prev || !dots || !next) return;
  const controls = document.createElement("div");
  controls.className = "slick-controls";
  controls.appendChild(prev);
  controls.appendChild(dots);
  controls.appendChild(next);
  slider.appendChild(controls);
}

window.openTab = function (e, tabId) {
  document
    .querySelectorAll(".tab-button")
    .forEach((b) => b.classList.remove("active"));
  document
    .querySelectorAll(".tab-content-about")
    .forEach((c) => c.classList.remove("active"));
  if (e.currentTarget) e.currentTarget.classList.add("active");
  const tab = document.getElementById(tabId);
  if (tab) tab.classList.add("active");
};

document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".komunita-gallery__slider");
  if (!slider) return;

  $(slider)
    .on("init", function () {
      createSlickControls(this);
    })
    .slick({
      slidesToShow: 4.4,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: true,
      responsive: [
        {
          breakpoint: 992,
          settings: { slidesToShow: 2 },
        },
        {
          breakpoint: 576,
          settings: { slidesToShow: 1.6 },
        },
      ],
    });
});

function initMobileCartButtons() {
  if (window.innerWidth > 767) return;
  document.querySelectorAll(".product .p").forEach((p) => {
    const tools = p.querySelector(".p-tools");
    if (!tools) return;
    const imageLink = p.querySelector(".image");
    if (imageLink) imageLink.appendChild(tools);
  });
}

function initCartShowRelated() {
  document.querySelectorAll("table.cart-table tr").forEach((tr) => {
    const link = tr.querySelector(".p-name .show-related");
    if (link) tr.appendChild(link);
  });
}

function categoryTopHandler() {
  const categoryTop = document.querySelector(".category-top");
  if (!categoryTop) return;
  const contentWrapper = document.querySelector(
    "#content-wrapper:has(.category-top)"
  );
  if (contentWrapper) {
    contentWrapper.before(categoryTop);
  }
}
categoryTopHandler();
// document.addEventListener("DOMContentLoaded", categoryTopHandler);

// ── Checkout footer contact info — edit here ──────────────

// ──────────────────────────────────────────────────────────

function initOrderingProcessFooter() {
  if (!document.body.classList.contains("ordering-process")) return;
  if (document.querySelector(".footer-utility-checkout")) return;

  const footer = document.querySelector("#content-wrapper");
  if (!footer) return;

  const el = document.createElement("div");
  el.className = "footer-utility-checkout";
  el.innerHTML = `
    <div class="footer-utility-checkout__inner">
      <div class="footer-utility-checkout__payments">
        <p class="footer-utility-checkout__payments-label">Bezpečná platba</p>
        <div class="footer-utility-checkout__payment-icons">
          <img src="/user/documents/upload/miranda/Payments.svg" alt="Bezpečné platební metody">
        </div>
      </div>
      <div class="footer-utility-checkout__info">
        <svg class="footer-utility-checkout__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="#F9A000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="footer-utility-checkout__text">
          <span class="footer-utility-checkout__label">Telefon</span>
          <a class="footer-utility-checkout__value" href="${CHECKOUT_PHONE_HREF}">${CHECKOUT_PHONE_DISPLAY}</a>
        </div>
      </div>
      <div class="footer-utility-checkout__info">
        <svg class="footer-utility-checkout__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="13" r="8" stroke="#F9A000" stroke-width="1.5"/>
          <path d="M12 9v4l2.5 2.5" stroke="#F9A000" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M9.5 3h5M12 3v2" stroke="#F9A000" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <div class="footer-utility-checkout__text">
          <span class="footer-utility-checkout__label">Zastihnete nás</span>
          <span class="footer-utility-checkout__value">${CHECKOUT_HOURS}</span>
        </div>
      </div>
      <div class="footer-utility-checkout__info">
        <svg class="footer-utility-checkout__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="4" width="20" height="16" rx="2" stroke="#F9A000" stroke-width="1.5"/>
          <path d="M22 7l-8.97 5.7a1.94 1.94 0 01-2.06 0L2 7" stroke="#F9A000" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <div class="footer-utility-checkout__text">
          <span class="footer-utility-checkout__label">E-mail</span>
          <a class="footer-utility-checkout__value" href="mailto:${CHECKOUT_EMAIL}">${CHECKOUT_EMAIL}</a>
        </div>
      </div>
    </div>
  `;

  footer.after(el);
}
document.addEventListener("DOMContentLoaded", initOrderingProcessFooter);

function initFavButtons() {
  const move = (el) => {
    const product = el.closest(".p");
    if (!product) return;
    const imageLink = product.querySelector(".image");
    if (!imageLink || imageLink.contains(el)) return;
    imageLink.appendChild(el);
    imageLink.addEventListener(
      "click",
      (e) => {
        if (el.contains(e.target)) e.preventDefault();
      },
      true
    );
  };

  document.querySelectorAll(".dkLabFavouriteProductDiv").forEach(move);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.classList?.contains("dkLabFavouriteProductDiv")) {
          move(node);
        } else {
          node.querySelectorAll?.(".dkLabFavouriteProductDiv").forEach(move);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function initLatestContributions() {
  const wrapper = document.querySelector(".latest-contribution-wrapper");
  if (!wrapper) return;

  // Collect all review links from all groups
  const allInners = [...wrapper.querySelectorAll(".latest-contribution-inner")];
  if (!allInners.length) return;

  // Build header with renamed title + slider arrows (same style as other sliders)
  const header = document.createElement("div");
  header.className = "lc-header";
  header.innerHTML = `
    <h2>Naší zákaznici hodnotí</h2>
    <div class="slider-arrows">
      <button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: inline-flex;">Previous</button>
      <button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: inline-flex;">Next</button>
    </div>
  `;

  // Build cards row
  const cardsRow = document.createElement("div");
  cardsRow.className = "lc-cards";

  allInners.forEach((inner) => {
    const href = inner.getAttribute("href") || "#";
    const author =
      inner.querySelector(".latest-contribution-author")?.textContent.trim() ||
      "";
    const starsHTML = inner.querySelector(".stars")?.outerHTML || "";
    const description =
      inner
        .querySelector(".latest-contribution-description")
        ?.textContent.trim() || "";
    const productName =
      inner.querySelector(".latest-contribution-product")?.textContent.trim() ||
      "";

    const card = document.createElement("a");
    card.className = "lc-card";
    card.href = href;
    card.innerHTML = `
      <div class="lc-card__header">
        <span class="lc-card__author">${author}</span>
        ${starsHTML}
      </div>
      <p class="lc-card__description">${description}</p>
      <div class="lc-card__footer">
        <span class="lc-card__label">Produkty:</span>
        <span class="lc-card__product">${productName}</span>
      </div>
    `;
    cardsRow.appendChild(card);
  });

  // Replace wrapper content
  wrapper.innerHTML = "";
  wrapper.appendChild(header);
  wrapper.appendChild(cardsRow);

  // Move box to correct position
  const box = wrapper.closest(".latest-contribution-box") || wrapper;
  if (window.innerWidth <= 767) {
    const anchor = document.querySelector(".row.banners-row");
    if (anchor) anchor.after(box);
  } else {
    const anchor = document.querySelector(
      "[data-testid='bannerTop']:has(.category-chips)"
    );
    if (anchor) anchor.after(box);
  }

  // Init Slick on the cards row, using the arrows injected into the header
  if (typeof $ !== "undefined" && typeof $.fn.slick !== "undefined") {
    const prevBtn = header.querySelector(".slick-prev");
    const nextBtn = header.querySelector(".slick-next");
    $(cardsRow).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: prevBtn,
      nextArrow: nextBtn,
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1260,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
}

document.addEventListener("DOMContentLoaded", initLatestContributions);
document.addEventListener("ShoptetDOMContentLoaded", initLatestContributions);
